import { sel } from "../../academy/selectors";
import { TutorialDefinition } from "../types";

/**
 * Academy lesson: Reports from audio → Combine recordings. Started from the
 * lesson page; never auto-started. The officer adds two of their own files,
 * then sees the type buttons, the reorder handle, and Report Settings. It
 * stops at the Upload button instead of creating a case.
 */
const tour: TutorialDefinition = {
  id: "combine-narrative-and-interaction",
  version: "1.0.0",
  releasedAt: "2026-10-29T00:00:00.000Z",
  category: "onboarding",
  title: "Combine recordings",
  description: "Put a narrative and an interaction in one case and order them.",
  triggerRoute: /^\/cases(\/.*)?$/,
  startRoute: "/cases",
  lessonId: "combine-narrative-and-interaction",
  autoStart: false,
  steps: [
    {
      target: sel("newCaseDropdown"),
      title: "Start a new case",
      content: "Click New Case, then choose Upload Files.",
      disableBeacon: true,
      placement: "right",
      advanceOn: { selector: sel("newCaseUpload"), event: "click" },
      hint: "Click New Case, then Upload Files to continue",
      spotlightClicks: true,
    },
    {
      target: sel("uploadDropzone"),
      waitFor: sel("uploadDropzone"),
      title: "Add more than one recording",
      content:
        "Drop in all the recordings at once, or add them one by one. Previous Uploads reuses a file from an earlier case. One case holds up to 10 files.",
      disableBeacon: true,
      placement: "bottom",
      advanceOn: {
        selector: `${sel("uploadDropzone")} input[type="file"]`,
        event: "change",
      },
      hint: "Choose two files to continue",
      spotlightClicks: true,
    },
    {
      target: '[data-file-index="0"]',
      waitFor: '[data-file-index="0"]',
      title: "Set each row's type",
      content:
        "Set each row to Narrative (you dictating) or Interaction (a conversation, with speakers). Add speakers to the interaction rows.",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: '[data-file-index="0"]',
      waitFor: '[data-file-index="0"]',
      title: "Drag to reorder chronologically",
      content:
        "Drag the rows into the order things happened. Your dictation usually goes last. The draft follows this order.",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: sel("uploadReportSettings"),
      waitFor: sel("uploadReportSettings"),
      title: "Report Settings",
      content: "Pick a template or a different Report Detail Level here if you want one.",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: sel("uploadSubmit"),
      waitFor: sel("uploadSubmit"),
      title: "Upload (N files)",
      content:
        "The button shows how many files you are uploading. Each file is transcribed on its own, and the draft starts when all of them finish. Stay on the page until the upload progress completes.",
      disableBeacon: true,
      placement: "top",
    },
  ],
};

export default tour;
